import {LineDashType} from '@/poster-whiteboard/items/line-item/line-item.types';
import type {LineDashOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-dash-option/line-dash-options.types';
import type {ItemType} from '@PosterWhiteboard/items/item/item.types';

export const getLineDashOptions = (): LineDashOptions[] => {
  return [
    {
      id: LineDashType.NONE,
    },
    {
      id: LineDashType.DASH,
    },
    {
      id: LineDashType.LONG_DASH,
    },
    {
      id: LineDashType.DOTED,
    },
    {
      id: LineDashType.DOT_DASH,
    },
    {
      id: LineDashType.CUSTOM,
    },
  ];
};

export const onUpdateGapSize = (activeItem: ItemType, gapSize: number, undoable = true): void => {
  if (gapSize <= 0) {
    return;
  }

  void activeItem.updateFromObject(
    {
      customGapSize: gapSize,
    },
    {
      undoable,
    }
  );
};
export const onUpdateDashSize = (activeItem: ItemType, dashSize: number, undoable = true): void => {
  if (dashSize <= 0) {
    return;
  }

  void activeItem.updateFromObject(
    {
      customDashSize: dashSize,
    },
    {
      undoable,
    }
  );
};
